export const GTAG_EVENTS = {
  PAGE_VIEW: 'page_view',
  VIEW_PROMOTION_FIRST500: 'view_promotion_first500',
  SELECT_PROMOTION_FIRST500: 'select_promotion_first500',
  PROMO_COPY_SUCCESS_FIRST500: 'promo_copy_success_first500',
  TOURS_TURAIKA_CLICK: 'tours_turaika_click',
  VIEW_TRAVEL_SERVICES: 'view_travel_services',
  SELECT_TRAVEL_SERVICE: 'select_travel_service',
  SERVICE_AVIA_CLICK: 'service_avia_click',
  SERVICE_TOURS_CLICK: 'service_tours_click',
  SERVICE_HOTELS_CLICK: 'service_hotels_click',
  SERVICE_EXCURSIONS_CLICK: 'service_excursions_click',
  NAV_HOME_CLICK: 'nav_home_click',
  NAV_ORDERS_CLICK: 'nav_orders_click',
  NAV_FAVORITES_CLICK: 'nav_favorites_click',
  NAV_PROFILE_CLICK: 'nav_profile_click',
  VZR_SEARCH_BANNER_CLICK: 'vzr_search_banner_click',
  ESIM_SEARCH_BANNER_CLICK: 'esim_search_banner_click',
} as const

export type GtagEventKey = keyof typeof GTAG_EVENTS
